module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/reputation-612cb9e25a64b17e2362fb63264d7e1f.png";